import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";

export const searchUsersApi = async (props: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.users.search, props);
};

export const getUserByIdApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.users.getUserById}?userId=${id}`
  );
};

export const updateUserApi = async (data: any, userId: string) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.users.updateUser}?userId=${userId}`,
    data
  );
};

export const getFitnessProfileByUserIdApi = async (id: string) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.users.getFitnessProfileByUserId}?userId=${id}`
  );
};

export const deleteUserApi = async (userId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.users.deleteUser}?userId=${userId}`
  );
};
